import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../AppContext';
import { useTranslation } from 'react-i18next';
import ProSubscriptionModal from '../ProSubscriptionModal';
import { httpsCallable } from 'firebase/functions';

const SubscriptionView = () => {
    const { t } = useTranslation();
    const { currentUserProfile, setShowProModal, appFunctions, setMessage } = useAppContext();
    const [showProSubscriptionModal, setShowProSubscriptionModal] = useState(false);
    const isPro = currentUserProfile?.proStatus === 'active';
    const hasSubscriptionId = !!currentUserProfile?.paypalSubscriptionId;

    useEffect(() => {
        if (isPro && !hasSubscriptionId) {
            const syncSubscription = httpsCallable(appFunctions, 'syncPayPalSubscription');
            syncSubscription()
                .then(() => {
                    setMessage("Subscription synced successfully!");
                })
                .catch((error) => {
                    console.error("Error syncing subscription:", error);
                    setMessage(error.message);
                });
        }
    }, [isPro, hasSubscriptionId, appFunctions, setMessage]);

    return (
        <>
            {showProSubscriptionModal && <ProSubscriptionModal onClose={() => setShowProSubscriptionModal(false)} />}
            <div className="bg-black/20 backdrop-blur-md rounded-2xl p-6 border border-slate-700/50">
                <h2 className="text-3xl font-bold font-playfair mb-2 text-purple-300">{t('settings.subscription.pro.title')}</h2>
                <p className="mb-6 text-gray-400">Unlock the full potential of your cosmic journey.</p>

                <div className="bg-purple-900/20 p-6 rounded-lg border border-purple-500/30 shadow-glow-purple-light">
                    {isPro ? (
                        <div>
                            <h3 className="text-xl font-semibold mb-2">Status: <span className="text-green-400">Active</span></h3>
                            <p className="text-gray-300 mb-4">Thank you for being a vital part of the Harmony ecosystem!</p>
                            <button
                                onClick={() => setShowProSubscriptionModal(true)}
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition duration-300 shadow-md hover:shadow-lg"
                            >
                                {t('settings.subscription.manage')}
                            </button>
                        </div>
                    ) : (
                        <div>
                            <h3 className="text-xl font-semibold mb-2">Upgrade to Harmony Pro</h3>
                            <ul className="list-disc list-inside mb-4 text-gray-300 space-y-2">
                                <li>{t('settings.subscription.pro.feature1')}</li>
                                <li>{t('settings.subscription.pro.feature2')}</li>
                                <li>{t('settings.subscription.pro.feature3')}</li>
                                <li>{t('settings.subscription.pro.feature4')}</li>
                            </ul>
                            <button
                                onClick={() => setShowProModal(true)}
                                className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-4 rounded-lg transition duration-300 shadow-lg hover:shadow-purple-500/50"
                            >
                                {t('settings.subscription.upgrade')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default SubscriptionView;
